import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import ReBox from "../../../../common/ReBox";
import { GlobalContext } from "../../../../common/Context";
import { blue, boxShadow, red } from "../../../../../theme/colours";
import { DriverScoreIcon } from "../../../../common/Icons";

const StatContainer = ({ width, colour, title, children, main }) => {
  const { desktopView } = useContext(GlobalContext);
  const headerColour = colour === blue[3] ? blue[1] : red[1];
  const isSpecial = !desktopView && main;

  const container = {
    display: "flex",
    flexDirection: isSpecial ? "row" : "column",
    width: width,
    borderRadius: "10px",
    mb: !desktopView ? "6%" : "0",
    overflow: "hidden",
    boxShadow: `0px 3px 6px ${boxShadow}`,
    ...(!desktopView &&
      !main && {
        flex: 1,
      }),
  };
  const headerBox = {
    width: "100%",
    backgroundColor: colour,
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: !desktopView && "column",
    ...(isSpecial && {
      pb: "2.5rem",
    }),
    "& svg *": {
      fill: headerColour,
    },
  };
  const iconStyle = {
    width: "35%",
    marginBottom: "0.75rem",
  };
  const headerText = {
    textTransform: "capitalize",
    textAlign: "center",
    fontWeight: isSpecial ? 700 : 500,
    fontSize: isSpecial && "0.875rem",
    color: isSpecial && headerColour,
  };
  const statBox = {
    display: "flex",
    width: "100%",
    padding: "0",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "none",
    borderRadius: 0,
    flexWrap: !desktopView && "wrap",
  };

  return (
    <Box sx={container}>
      <Box sx={headerBox}>
        {isSpecial && <DriverScoreIcon style={iconStyle} />}
        <Typography sx={headerText}>{title}</Typography>
      </Box>
      <ReBox style={statBox}>{children}</ReBox>
    </Box>
  );
};

export default StatContainer;
